/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadBase.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadBase>): BackgroundJobPayloadBase {
        let obj = Object.assign(new BackgroundJobPayloadBase(), model);
        BackgroundJobPayloadBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadBase>): BackgroundJobPayloadBase {
        if (!model) return null;
        return BackgroundJobPayloadBase.newInstance(<BackgroundJobPayloadBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadBase) {
        if (!obj) return;

        models.BackgroundJobPayloadBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadBase): boolean {
        switch (obj.__type)
        {
            case "BackgroundJobPayloadForAIAgentsTraceCollector":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAIAgentsTraceCollector.prototype);
                break;
            case "BackgroundJobPayloadForAIUnitEconomicsCost":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAIUnitEconomicsCost.prototype);
                break;
            case "BackgroundJobPayloadForAccessGovernance":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAccessGovernance.prototype);
                break;
            case "BackgroundJobPayloadForActivityExecutor":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForActivityExecutor.prototype);
                break;
            case "BackgroundJobPayloadForAiAgentReportHandler":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAiAgentReportHandler.prototype);
                break;
            case "BackgroundJobPayloadForAiTelemetryIngestion":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAiTelemetryIngestion.prototype);
                break;
            case "BackgroundJobPayloadForAiUsageBilling":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAiUsageBilling.prototype);
                break;
            case "BackgroundJobPayloadForAlertReconciliation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAlertReconciliation.prototype);
                break;
            case "BackgroundJobPayloadForAppSecopsEntityBulkUpdate":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAppSecopsEntityBulkUpdate.prototype);
                break;
            case "BackgroundJobPayloadForAssessmentDataCollection":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAssessmentDataCollection.prototype);
                break;
            case "BackgroundJobPayloadForAssessmentFramework":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAssessmentFramework.prototype);
                break;
            case "BackgroundJobPayloadForAssessmentFrameworkOntologySync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAssessmentFrameworkOntologySync.prototype);
                break;
            case "BackgroundJobPayloadForAssessmentFrameworkRun":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAssessmentFrameworkRun.prototype);
                break;
            case "BackgroundJobPayloadForAssessmentReportOntologyMigration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAssessmentReportOntologyMigration.prototype);
                break;
            case "BackgroundJobPayloadForAssessmentRun":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAssessmentRun.prototype);
                break;
            case "BackgroundJobPayloadForAssessmentRunReport":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAssessmentRunReport.prototype);
                break;
            case "BackgroundJobPayloadForAssessmentRunScan":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAssessmentRunScan.prototype);
                break;
            case "BackgroundJobPayloadForAssessmentRunTtlGeneration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAssessmentRunTtlGeneration.prototype);
                break;
            case "BackgroundJobPayloadForAssessmentRunTtlRefresh":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAssessmentRunTtlRefresh.prototype);
                break;
            case "BackgroundJobPayloadForAutoAssessment":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAutoAssessment.prototype);
                break;
            case "BackgroundJobPayloadForAwsSsmAutomationExecutionJobs":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAwsSsmAutomationExecutionJobs.prototype);
                break;
            case "BackgroundJobPayloadForAwsSsmCommandExecution":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAwsSsmCommandExecution.prototype);
                break;
            case "BackgroundJobPayloadForAwsSsmCommandExecutionJobs":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAwsSsmCommandExecutionJobs.prototype);
                break;
            case "BackgroundJobPayloadForAwsSsmDocuments":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForAwsSsmDocuments.prototype);
                break;
            case "BackgroundJobPayloadForBackupConfiguration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForBackupConfiguration.prototype);
                break;
            case "BackgroundJobPayloadForBillingEntryCleanup":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForBillingEntryCleanup.prototype);
                break;
            case "BackgroundJobPayloadForBillingOntologyBudgetSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForBillingOntologyBudgetSync.prototype);
                break;
            case "BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc.prototype);
                break;
            case "BackgroundJobPayloadForBillingOntologySync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForBillingOntologySync.prototype);
                break;
            case "BackgroundJobPayloadForBillingOntologySyncAdhoc":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForBillingOntologySyncAdhoc.prototype);
                break;
            case "BackgroundJobPayloadForBillingPlanEvaluation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForBillingPlanEvaluation.prototype);
                break;
            case "BackgroundJobPayloadForBillingResourceGraphDBSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForBillingResourceGraphDBSync.prototype);
                break;
            case "BackgroundJobPayloadForBlueprintExecution":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForBlueprintExecution.prototype);
                break;
            case "BackgroundJobPayloadForBudgetAlertNotification":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForBudgetAlertNotification.prototype);
                break;
            case "BackgroundJobPayloadForBudgetAlertTrigger":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForBudgetAlertTrigger.prototype);
                break;
            case "BackgroundJobPayloadForBudgetCost":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForBudgetCost.prototype);
                break;
            case "BackgroundJobPayloadForBudgetSettings":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForBudgetSettings.prototype);
                break;
            case "BackgroundJobPayloadForBulkPolicyTrigger":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForBulkPolicyTrigger.prototype);
                break;
            case "BackgroundJobPayloadForCfnTemplateExecution":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCfnTemplateExecution.prototype);
                break;
            case "BackgroundJobPayloadForCloudHealthMonitoring":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCloudHealthMonitoring.prototype);
                break;
            case "BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless.prototype);
                break;
            case "BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand.prototype);
                break;
            case "BackgroundJobPayloadForCloudUsageBilling":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCloudUsageBilling.prototype);
                break;
            case "BackgroundJobPayloadForCloudUsageBillingAggregation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCloudUsageBillingAggregation.prototype);
                break;
            case "BackgroundJobPayloadForCloudUsageBillingMigration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCloudUsageBillingMigration.prototype);
                break;
            case "BackgroundJobPayloadForCloudUsageBillingMigrationPropagation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCloudUsageBillingMigrationPropagation.prototype);
                break;
            case "BackgroundJobPayloadForComplianceControl":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForComplianceControl.prototype);
                break;
            case "BackgroundJobPayloadForComplianceStandard":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForComplianceStandard.prototype);
                break;
            case "BackgroundJobPayloadForContainerFindingsParser":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForContainerFindingsParser.prototype);
                break;
            case "BackgroundJobPayloadForCopilotGovernanceMetricsProcessor":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCopilotGovernanceMetricsProcessor.prototype);
                break;
            case "BackgroundJobPayloadForCostAnomalyDailySummaryNotification":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCostAnomalyDailySummaryNotification.prototype);
                break;
            case "BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions.prototype);
                break;
            case "BackgroundJobPayloadForCostAnomalyDetector":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCostAnomalyDetector.prototype);
                break;
            case "BackgroundJobPayloadForCostAnomalyDetectorForDimensions":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCostAnomalyDetectorForDimensions.prototype);
                break;
            case "BackgroundJobPayloadForCostAnomalyDetectorForResources":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCostAnomalyDetectorForResources.prototype);
                break;
            case "BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync.prototype);
                break;
            case "BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc.prototype);
                break;
            case "BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync.prototype);
                break;
            case "BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc.prototype);
                break;
            case "BackgroundJobPayloadForCrpRecommendations":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCrpRecommendations.prototype);
                break;
            case "BackgroundJobPayloadForCspServiceAccountMigration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCspServiceAccountMigration.prototype);
                break;
            case "BackgroundJobPayloadForCustomMetricConfigurationSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForCustomMetricConfigurationSync.prototype);
                break;
            case "BackgroundJobPayloadForDailyCostReport":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForDailyCostReport.prototype);
                break;
            case "BackgroundJobPayloadForDailyGovernanceReport":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForDailyGovernanceReport.prototype);
                break;
            case "BackgroundJobPayloadForDailyInventoryReport":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForDailyInventoryReport.prototype);
                break;
            case "BackgroundJobPayloadForDefaultWorkloadCreation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForDefaultWorkloadCreation.prototype);
                break;
            case "BackgroundJobPayloadForDimensionGraphDBSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForDimensionGraphDBSync.prototype);
                break;
            case "BackgroundJobPayloadForDimensionGraphDBSyncAdhoc":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForDimensionGraphDBSyncAdhoc.prototype);
                break;
            case "BackgroundJobPayloadForEngineTest":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForEngineTest.prototype);
                break;
            case "BackgroundJobPayloadForExecutiveDashboardReport":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForExecutiveDashboardReport.prototype);
                break;
            case "BackgroundJobPayloadForExtendedResourceDiscovery":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForExtendedResourceDiscovery.prototype);
                break;
            case "BackgroundJobPayloadForFinOpsAiOntologySync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForFinOpsAiOntologySync.prototype);
                break;
            case "BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc.prototype);
                break;
            case "BackgroundJobPayloadForGenericTask":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForGenericTask.prototype);
                break;
            case "BackgroundJobPayloadForGraphionRiskScoreUpdate":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForGraphionRiskScoreUpdate.prototype);
                break;
            case "BackgroundJobPayloadForIdentityOntologyEventSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForIdentityOntologyEventSync.prototype);
                break;
            case "BackgroundJobPayloadForIdentityOntologySync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForIdentityOntologySync.prototype);
                break;
            case "BackgroundJobPayloadForIdentityOntologySyncAdhoc":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForIdentityOntologySyncAdhoc.prototype);
                break;
            case "BackgroundJobPayloadForIntegratedToolsAlert":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForIntegratedToolsAlert.prototype);
                break;
            case "BackgroundJobPayloadForInventoryUnitRate":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForInventoryUnitRate.prototype);
                break;
            case "BackgroundJobPayloadForKubernetesClusterBilling":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForKubernetesClusterBilling.prototype);
                break;
            case "BackgroundJobPayloadForKubernetesClusterUsageBilling":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForKubernetesClusterUsageBilling.prototype);
                break;
            case "BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh.prototype);
                break;
            case "BackgroundJobPayloadForMasterDataTtlGeneration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForMasterDataTtlGeneration.prototype);
                break;
            case "BackgroundJobPayloadForMetricValueStorage":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForMetricValueStorage.prototype);
                break;
            case "BackgroundJobPayloadForMistralTemplateExecution":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForMistralTemplateExecution.prototype);
                break;
            case "BackgroundJobPayloadForModelSwitching":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForModelSwitching.prototype);
                break;
            case "BackgroundJobPayloadForMonthlyCostReport":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForMonthlyCostReport.prototype);
                break;
            case "BackgroundJobPayloadForNextGenReportHandler":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForNextGenReportHandler.prototype);
                break;
            case "BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules.prototype);
                break;
            case "BackgroundJobPayloadForOnpremAlertChecker":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForOnpremAlertChecker.prototype);
                break;
            case "BackgroundJobPayloadForOnpremMetricDataParser":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForOnpremMetricDataParser.prototype);
                break;
            case "BackgroundJobPayloadForOperationAssessment":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForOperationAssessment.prototype);
                break;
            case "BackgroundJobPayloadForOrphanedCloudMonitoringAlert":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForOrphanedCloudMonitoringAlert.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAIAgentsTraceCollector":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAIAgentsTraceCollector.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAIUnitEconomicsCost":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAIUnitEconomicsCost.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAccessGovernance":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAccessGovernance.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAccessValidation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAccessValidation.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAiTelemetryIngestion":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAiTelemetryIngestion.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAiUsageBilling":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAiUsageBilling.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAlertConfiguration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAlertConfiguration.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAlertReconciliation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAlertReconciliation.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAssessmentDataCollection":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAssessmentDataCollection.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAssessmentGovernanceCost":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAssessmentGovernanceCost.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAwsSsmDocuments":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAwsSsmDocuments.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAwsWorkspace":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAwsWorkspace.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAzureRecommendationsSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAzureRecommendationsSync.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAzureSecurityGraph":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAzureSecurityGraph.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicAzureSentinelUpdate":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicAzureSentinelUpdate.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicBackupConfiguration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicBackupConfiguration.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicBenchmarkCatalogue":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicBenchmarkCatalogue.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicBillingEntryCleanup":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicBillingEntryCleanup.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicBudgetAlert":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicBudgetAlert.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicBudgetCost":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicBudgetCost.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicBudgetHistoryBackfill":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicBudgetHistoryBackfill.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicBudgetInsights":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicBudgetInsights.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicBudgetSettings":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicBudgetSettings.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCloudAccountTagSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCloudAccountTagSync.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCloudHealthMonitoring":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCloudHealthMonitoring.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCloudNativeThreatSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCloudNativeThreatSync.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCloudOpsInsight":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCloudOpsInsight.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCloudUsageBilling":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCloudUsageBilling.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCloudWatchMetrics":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCloudWatchMetrics.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicComplianceRefresh":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicComplianceRefresh.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCostSavingsCalculation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCostSavingsCalculation.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCreateAlertForNewResources":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCreateAlertForNewResources.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCredentialExpirationCheck":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCredentialExpirationCheck.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCrpRecommendations":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCrpRecommendations.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicCustomWorkflowManager":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicCustomWorkflowManager.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicDailyCostReport":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicDailyCostReport.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicDailyGovernanceReport":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicDailyGovernanceReport.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicDailyInventoryReport":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicDailyInventoryReport.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicDiskUtilization":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicDiskUtilization.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicGovernanceInstanceStatus":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicGovernanceInstanceStatus.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicGovernanceNotification":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicGovernanceNotification.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicInventoryUnitRate":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicInventoryUnitRate.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicJiraChangeManagementHandler":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicJiraChangeManagementHandler.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicMarketPlacePoller":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicMarketPlacePoller.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicMasterDataTtlGeneration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicMasterDataTtlGeneration.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicMetricValueStorage":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicMetricValueStorage.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicMetricsUtilization":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicMetricsUtilization.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicModelSwitching":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicModelSwitching.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicMonthlyCostReport":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicMonthlyCostReport.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicOperationAssessment":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicOperationAssessment.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicOrphanedJobRecovery":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicOrphanedJobRecovery.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicParseNetworkDetails":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicParseNetworkDetails.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicPatchManager":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicPatchManager.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicPolicyRefresh":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicPolicyRefresh.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicPromptCaching":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicPromptCaching.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicPromptParser":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicPromptParser.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicPromptProfiling":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicPromptProfiling.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicProviderRecommendations":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicProviderRecommendations.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicRecommendationV2Processor":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicRecommendationV2Processor.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicRecoveryConfiguration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicRecoveryConfiguration.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicRefreshUtilizationSummary":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicRefreshUtilizationSummary.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicReservedInstance":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicReservedInstance.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicResourceDiscovery":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicResourceDiscovery.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicSaasCostProcessing":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicSaasCostProcessing.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicSavingsPlans":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicSavingsPlans.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicScheduleRecommendation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicScheduleRecommendation.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicSecureScoresConfiguration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicSecureScoresConfiguration.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicServiceAccountDelete":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicServiceAccountDelete.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicServiceAccountMaintenance":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicServiceAccountMaintenance.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicServiceImpactAnalysis":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicServiceImpactAnalysis.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicServiceResourceBillingCategory":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicServiceResourceBillingCategory.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicSyncBudgets":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicSyncBudgets.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicSynchronizeNirmata":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicSynchronizeNirmata.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicTagDiscovery":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicTagDiscovery.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicTenableNessus":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicTenableNessus.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicUnitPriceRate":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicUnitPriceRate.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicValidateCredentials":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicValidateCredentials.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicVirtualMachinesAgents":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicVirtualMachinesAgents.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly.prototype);
                break;
            case "BackgroundJobPayloadForPeriodicZabbixGovernance":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPeriodicZabbixGovernance.prototype);
                break;
            case "BackgroundJobPayloadForPolicyExecution":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPolicyExecution.prototype);
                break;
            case "BackgroundJobPayloadForPolicyJobStatusUpdate":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPolicyJobStatusUpdate.prototype);
                break;
            case "BackgroundJobPayloadForPolicyOntologyMigration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPolicyOntologyMigration.prototype);
                break;
            case "BackgroundJobPayloadForPolicyResourceRecommendationRemoval":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPolicyResourceRecommendationRemoval.prototype);
                break;
            case "BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand.prototype);
                break;
            case "BackgroundJobPayloadForPromptCaching":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPromptCaching.prototype);
                break;
            case "BackgroundJobPayloadForPromptProfiling":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForPromptProfiling.prototype);
                break;
            case "BackgroundJobPayloadForProviderRecommendations":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForProviderRecommendations.prototype);
                break;
            case "BackgroundJobPayloadForReactiveTask":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForReactiveTask.prototype);
                break;
            case "BackgroundJobPayloadForRecoveryConfiguration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForRecoveryConfiguration.prototype);
                break;
            case "BackgroundJobPayloadForRefreshRecommendation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForRefreshRecommendation.prototype);
                break;
            case "BackgroundJobPayloadForRemediationTemplateExecutor":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForRemediationTemplateExecutor.prototype);
                break;
            case "BackgroundJobPayloadForReportGeneration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForReportGeneration.prototype);
                break;
            case "BackgroundJobPayloadForReservedInstance":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForReservedInstance.prototype);
                break;
            case "BackgroundJobPayloadForResourceActivityLogSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForResourceActivityLogSync.prototype);
                break;
            case "BackgroundJobPayloadForResourceAlertConfiguration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForResourceAlertConfiguration.prototype);
                break;
            case "BackgroundJobPayloadForResourceDashboard":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForResourceDashboard.prototype);
                break;
            case "BackgroundJobPayloadForResourceDependencyRelationship":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForResourceDependencyRelationship.prototype);
                break;
            case "BackgroundJobPayloadForResourceDiscovery":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForResourceDiscovery.prototype);
                break;
            case "BackgroundJobPayloadForResourceDiscoveryExecution":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForResourceDiscoveryExecution.prototype);
                break;
            case "BackgroundJobPayloadForResourceLockSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForResourceLockSync.prototype);
                break;
            case "BackgroundJobPayloadForResourceTagRemediation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForResourceTagRemediation.prototype);
                break;
            case "BackgroundJobPayloadForResourceToSbomMappingAutomatic":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForResourceToSbomMappingAutomatic.prototype);
                break;
            case "BackgroundJobPayloadForResourcesDuplicationRemoval":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForResourcesDuplicationRemoval.prototype);
                break;
            case "BackgroundJobPayloadForSaasCostProcessing":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForSaasCostProcessing.prototype);
                break;
            case "BackgroundJobPayloadForSbomParser":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForSbomParser.prototype);
                break;
            case "BackgroundJobPayloadForSbomToResourceMappingAutomatic":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForSbomToResourceMappingAutomatic.prototype);
                break;
            case "BackgroundJobPayloadForScheduleRecommendation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForScheduleRecommendation.prototype);
                break;
            case "BackgroundJobPayloadForScheduledTask":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForScheduledTask.prototype);
                break;
            case "BackgroundJobPayloadForScriptExecution":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForScriptExecution.prototype);
                break;
            case "BackgroundJobPayloadForSecureScoresConfiguration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForSecureScoresConfiguration.prototype);
                break;
            case "BackgroundJobPayloadForServiceAccountDelete":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForServiceAccountDelete.prototype);
                break;
            case "BackgroundJobPayloadForServiceAccountFeaturePropagation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForServiceAccountFeaturePropagation.prototype);
                break;
            case "BackgroundJobPayloadForServiceAccountGovernancePropagation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForServiceAccountGovernancePropagation.prototype);
                break;
            case "BackgroundJobPayloadForServiceAccountResourceOntologySync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForServiceAccountResourceOntologySync.prototype);
                break;
            case "BackgroundJobPayloadForServiceAccountSyncStatusPropagation":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForServiceAccountSyncStatusPropagation.prototype);
                break;
            case "BackgroundJobPayloadForServiceImpactAnalysis":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForServiceImpactAnalysis.prototype);
                break;
            case "BackgroundJobPayloadForSyncBudgets":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForSyncBudgets.prototype);
                break;
            case "BackgroundJobPayloadForTagDiscovery":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForTagDiscovery.prototype);
                break;
            case "BackgroundJobPayloadForTagPosture":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForTagPosture.prototype);
                break;
            case "BackgroundJobPayloadForTagPostureSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForTagPostureSync.prototype);
                break;
            case "BackgroundJobPayloadForTemplateExecution":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForTemplateExecution.prototype);
                break;
            case "BackgroundJobPayloadForTerraformTemplateExecution":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForTerraformTemplateExecution.prototype);
                break;
            case "BackgroundJobPayloadForThreatResourceActiveRefresh":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForThreatResourceActiveRefresh.prototype);
                break;
            case "BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync.prototype);
                break;
            case "BackgroundJobPayloadForUnitRateCrawler":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForUnitRateCrawler.prototype);
                break;
            case "BackgroundJobPayloadForUpdateUnitRate":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForUpdateUnitRate.prototype);
                break;
            case "BackgroundJobPayloadForVirtualMachinesAgents":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForVirtualMachinesAgents.prototype);
                break;
            case "BackgroundJobPayloadForWorkFlowReconciller":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForWorkFlowReconciller.prototype);
                break;
            case "BackgroundJobPayloadForWorkloadOntologyMigration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForWorkloadOntologyMigration.prototype);
                break;
            case "BackgroundJobPayloadForWorkloadResourceSnapshot":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForWorkloadResourceSnapshot.prototype);
                break;
            case "BackgroundJobPayloadForWorkloadResourceSync":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForWorkloadResourceSync.prototype);
                break;
            case "BackgroundJobPayloadForWorkloadTtlGeneration":
                Object.setPrototypeOf(obj, models.BackgroundJobPayloadForWorkloadTtlGeneration.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof BackgroundJobPayloadBase)[] {
        return [
            models.BackgroundJobPayloadForAIAgentsTraceCollector,
            models.BackgroundJobPayloadForAIUnitEconomicsCost,
            models.BackgroundJobPayloadForAccessGovernance,
            models.BackgroundJobPayloadForActivityExecutor,
            models.BackgroundJobPayloadForAiAgentReportHandler,
            models.BackgroundJobPayloadForAiTelemetryIngestion,
            models.BackgroundJobPayloadForAiUsageBilling,
            models.BackgroundJobPayloadForAlertReconciliation,
            models.BackgroundJobPayloadForAppSecopsEntityBulkUpdate,
            models.BackgroundJobPayloadForAssessmentDataCollection,
            models.BackgroundJobPayloadForAssessmentFramework,
            models.BackgroundJobPayloadForAssessmentFrameworkOntologySync,
            models.BackgroundJobPayloadForAssessmentFrameworkRun,
            models.BackgroundJobPayloadForAssessmentReportOntologyMigration,
            models.BackgroundJobPayloadForAssessmentRun,
            models.BackgroundJobPayloadForAssessmentRunReport,
            models.BackgroundJobPayloadForAssessmentRunScan,
            models.BackgroundJobPayloadForAssessmentRunTtlGeneration,
            models.BackgroundJobPayloadForAssessmentRunTtlRefresh,
            models.BackgroundJobPayloadForAutoAssessment,
            models.BackgroundJobPayloadForAwsSsmAutomationExecutionJobs,
            models.BackgroundJobPayloadForAwsSsmCommandExecution,
            models.BackgroundJobPayloadForAwsSsmCommandExecutionJobs,
            models.BackgroundJobPayloadForAwsSsmDocuments,
            models.BackgroundJobPayloadForBackupConfiguration,
            models.BackgroundJobPayloadForBillingEntryCleanup,
            models.BackgroundJobPayloadForBillingOntologyBudgetSync,
            models.BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc,
            models.BackgroundJobPayloadForBillingOntologySync,
            models.BackgroundJobPayloadForBillingOntologySyncAdhoc,
            models.BackgroundJobPayloadForBillingPlanEvaluation,
            models.BackgroundJobPayloadForBillingResourceGraphDBSync,
            models.BackgroundJobPayloadForBlueprintExecution,
            models.BackgroundJobPayloadForBudgetAlertNotification,
            models.BackgroundJobPayloadForBudgetAlertTrigger,
            models.BackgroundJobPayloadForBudgetCost,
            models.BackgroundJobPayloadForBudgetSettings,
            models.BackgroundJobPayloadForBulkPolicyTrigger,
            models.BackgroundJobPayloadForCfnTemplateExecution,
            models.BackgroundJobPayloadForCloudHealthMonitoring,
            models.BackgroundJobPayloadForCloudHealthMonitoringMetricSyncerStateless,
            models.BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand,
            models.BackgroundJobPayloadForCloudUsageBilling,
            models.BackgroundJobPayloadForCloudUsageBillingAggregation,
            models.BackgroundJobPayloadForCloudUsageBillingMigration,
            models.BackgroundJobPayloadForCloudUsageBillingMigrationPropagation,
            models.BackgroundJobPayloadForComplianceControl,
            models.BackgroundJobPayloadForComplianceStandard,
            models.BackgroundJobPayloadForContainerFindingsParser,
            models.BackgroundJobPayloadForCopilotGovernanceMetricsProcessor,
            models.BackgroundJobPayloadForCostAnomalyDailySummaryNotification,
            models.BackgroundJobPayloadForCostAnomalyDailySummaryNotificationForDimensions,
            models.BackgroundJobPayloadForCostAnomalyDetector,
            models.BackgroundJobPayloadForCostAnomalyDetectorForDimensions,
            models.BackgroundJobPayloadForCostAnomalyDetectorForResources,
            models.BackgroundJobPayloadForCostAnomalyDetectorGraphDBSync,
            models.BackgroundJobPayloadForCostAnomalyDetectorGraphDBSyncAdhoc,
            models.BackgroundJobPayloadForCostAnomalyDimensionGraphDBSync,
            models.BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc,
            models.BackgroundJobPayloadForCrpRecommendations,
            models.BackgroundJobPayloadForCspServiceAccountMigration,
            models.BackgroundJobPayloadForCustomMetricConfigurationSync,
            models.BackgroundJobPayloadForDailyCostReport,
            models.BackgroundJobPayloadForDailyGovernanceReport,
            models.BackgroundJobPayloadForDailyInventoryReport,
            models.BackgroundJobPayloadForDefaultWorkloadCreation,
            models.BackgroundJobPayloadForDimensionGraphDBSync,
            models.BackgroundJobPayloadForDimensionGraphDBSyncAdhoc,
            models.BackgroundJobPayloadForEngineTest,
            models.BackgroundJobPayloadForExecutiveDashboardReport,
            models.BackgroundJobPayloadForExtendedResourceDiscovery,
            models.BackgroundJobPayloadForFinOpsAiOntologySync,
            models.BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc,
            models.BackgroundJobPayloadForGenericTask,
            models.BackgroundJobPayloadForGraphionRiskScoreUpdate,
            models.BackgroundJobPayloadForIdentityOntologyEventSync,
            models.BackgroundJobPayloadForIdentityOntologySync,
            models.BackgroundJobPayloadForIdentityOntologySyncAdhoc,
            models.BackgroundJobPayloadForIntegratedToolsAlert,
            models.BackgroundJobPayloadForInventoryUnitRate,
            models.BackgroundJobPayloadForKubernetesClusterBilling,
            models.BackgroundJobPayloadForKubernetesClusterUsageBilling,
            models.BackgroundJobPayloadForKubernetesClusterUsageBillingFullRefresh,
            models.BackgroundJobPayloadForMasterDataTtlGeneration,
            models.BackgroundJobPayloadForMetricValueStorage,
            models.BackgroundJobPayloadForMistralTemplateExecution,
            models.BackgroundJobPayloadForModelSwitching,
            models.BackgroundJobPayloadForMonthlyCostReport,
            models.BackgroundJobPayloadForNextGenReportHandler,
            models.BackgroundJobPayloadForOnDemandApplyRecommendationExclusionRules,
            models.BackgroundJobPayloadForOnpremAlertChecker,
            models.BackgroundJobPayloadForOnpremMetricDataParser,
            models.BackgroundJobPayloadForOperationAssessment,
            models.BackgroundJobPayloadForOrphanedCloudMonitoringAlert,
            models.BackgroundJobPayloadForPeriodicAIAgentsTraceCollector,
            models.BackgroundJobPayloadForPeriodicAIUnitEconomicsCost,
            models.BackgroundJobPayloadForPeriodicAccessGovernance,
            models.BackgroundJobPayloadForPeriodicAccessValidation,
            models.BackgroundJobPayloadForPeriodicAiTelemetryIngestion,
            models.BackgroundJobPayloadForPeriodicAiUsageBilling,
            models.BackgroundJobPayloadForPeriodicAlertConfiguration,
            models.BackgroundJobPayloadForPeriodicAlertReconciliation,
            models.BackgroundJobPayloadForPeriodicApplicationPerformanceMonitoring,
            models.BackgroundJobPayloadForPeriodicAssessmentDataCollection,
            models.BackgroundJobPayloadForPeriodicAssessmentGovernanceCost,
            models.BackgroundJobPayloadForPeriodicAwsSecurityHubFindingsSync,
            models.BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress,
            models.BackgroundJobPayloadForPeriodicAwsSsmCommandExecutionProgress,
            models.BackgroundJobPayloadForPeriodicAwsSsmDocuments,
            models.BackgroundJobPayloadForPeriodicAwsWorkspace,
            models.BackgroundJobPayloadForPeriodicAzureRecommendationsSync,
            models.BackgroundJobPayloadForPeriodicAzureSecurityGraph,
            models.BackgroundJobPayloadForPeriodicAzureSentinelUpdate,
            models.BackgroundJobPayloadForPeriodicBackupConfiguration,
            models.BackgroundJobPayloadForPeriodicBenchmarkCatalogue,
            models.BackgroundJobPayloadForPeriodicBillingEntryCleanup,
            models.BackgroundJobPayloadForPeriodicBudgetAlert,
            models.BackgroundJobPayloadForPeriodicBudgetCost,
            models.BackgroundJobPayloadForPeriodicBudgetHistoryBackfill,
            models.BackgroundJobPayloadForPeriodicBudgetInsights,
            models.BackgroundJobPayloadForPeriodicBudgetSettings,
            models.BackgroundJobPayloadForPeriodicCloudAccountTagSync,
            models.BackgroundJobPayloadForPeriodicCloudHealthMonitoring,
            models.BackgroundJobPayloadForPeriodicCloudNativeThreatSync,
            models.BackgroundJobPayloadForPeriodicCloudNativeVulnerabilitySync,
            models.BackgroundJobPayloadForPeriodicCloudOpsInsight,
            models.BackgroundJobPayloadForPeriodicCloudUsageBilling,
            models.BackgroundJobPayloadForPeriodicCloudWatchMetrics,
            models.BackgroundJobPayloadForPeriodicCloudWatchMetricsConfiguration,
            models.BackgroundJobPayloadForPeriodicComplianceRefresh,
            models.BackgroundJobPayloadForPeriodicCopilotGovernanceMetricsProcessor,
            models.BackgroundJobPayloadForPeriodicCostAnomalyDailySummaryNotification,
            models.BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions,
            models.BackgroundJobPayloadForPeriodicCostSavingsCalculation,
            models.BackgroundJobPayloadForPeriodicCreateActivityMasterTemplate,
            models.BackgroundJobPayloadForPeriodicCreateAlertForNewResources,
            models.BackgroundJobPayloadForPeriodicCreateMetricMasterTemplate,
            models.BackgroundJobPayloadForPeriodicCredentialExpirationCheck,
            models.BackgroundJobPayloadForPeriodicCrpRecommendations,
            models.BackgroundJobPayloadForPeriodicCustomMetricConfigurationSync,
            models.BackgroundJobPayloadForPeriodicCustomWorkflowManager,
            models.BackgroundJobPayloadForPeriodicDailyCostReport,
            models.BackgroundJobPayloadForPeriodicDailyGovernanceReport,
            models.BackgroundJobPayloadForPeriodicDailyInventoryReport,
            models.BackgroundJobPayloadForPeriodicDailyPolicyRecommendationGraphDBSync,
            models.BackgroundJobPayloadForPeriodicDiskUtilization,
            models.BackgroundJobPayloadForPeriodicGovernanceConfigurationValidation,
            models.BackgroundJobPayloadForPeriodicGovernanceInstanceStatus,
            models.BackgroundJobPayloadForPeriodicGovernanceNotification,
            models.BackgroundJobPayloadForPeriodicInventoryUnitRate,
            models.BackgroundJobPayloadForPeriodicJiraChangeManagementHandler,
            models.BackgroundJobPayloadForPeriodicLogAnalyticsWorkspace,
            models.BackgroundJobPayloadForPeriodicLogAnalyticsWorkspaceSync,
            models.BackgroundJobPayloadForPeriodicMarketPlacePoller,
            models.BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration,
            models.BackgroundJobPayloadForPeriodicMasterDataTtlGeneration,
            models.BackgroundJobPayloadForPeriodicMetricValueStorage,
            models.BackgroundJobPayloadForPeriodicMetricsToAnomalyDetection,
            models.BackgroundJobPayloadForPeriodicMetricsUtilization,
            models.BackgroundJobPayloadForPeriodicModelSwitching,
            models.BackgroundJobPayloadForPeriodicMonthlyCostReport,
            models.BackgroundJobPayloadForPeriodicOnboardAndUpdateGCPAndAWSHierarchy,
            models.BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup,
            models.BackgroundJobPayloadForPeriodicOperationAssessment,
            models.BackgroundJobPayloadForPeriodicOrphanedJobRecovery,
            models.BackgroundJobPayloadForPeriodicParseNetworkDetails,
            models.BackgroundJobPayloadForPeriodicPatchManager,
            models.BackgroundJobPayloadForPeriodicPolicyRefresh,
            models.BackgroundJobPayloadForPeriodicProActiveScannerDetailsParser,
            models.BackgroundJobPayloadForPeriodicProcessAlertTemplateStatusUpdate,
            models.BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords,
            models.BackgroundJobPayloadForPeriodicPromptCaching,
            models.BackgroundJobPayloadForPeriodicPromptParser,
            models.BackgroundJobPayloadForPeriodicPromptProfiling,
            models.BackgroundJobPayloadForPeriodicProviderRecommendations,
            models.BackgroundJobPayloadForPeriodicRecommendationV2Processor,
            models.BackgroundJobPayloadForPeriodicRecoveryConfiguration,
            models.BackgroundJobPayloadForPeriodicRefreshUtilizationSummary,
            models.BackgroundJobPayloadForPeriodicReservedInstance,
            models.BackgroundJobPayloadForPeriodicResourceDiscovery,
            models.BackgroundJobPayloadForPeriodicSaasCostProcessing,
            models.BackgroundJobPayloadForPeriodicSavingsPlans,
            models.BackgroundJobPayloadForPeriodicScheduleRecommendation,
            models.BackgroundJobPayloadForPeriodicSecureScoresConfiguration,
            models.BackgroundJobPayloadForPeriodicServiceAccountDelete,
            models.BackgroundJobPayloadForPeriodicServiceAccountMaintenance,
            models.BackgroundJobPayloadForPeriodicServiceImpactAnalysis,
            models.BackgroundJobPayloadForPeriodicServiceNowChangeStatusTracker,
            models.BackgroundJobPayloadForPeriodicServiceResourceBillingCategory,
            models.BackgroundJobPayloadForPeriodicSyncAccountSubscriptionAndMetadata,
            models.BackgroundJobPayloadForPeriodicSyncBudgets,
            models.BackgroundJobPayloadForPeriodicSynchronizeNirmata,
            models.BackgroundJobPayloadForPeriodicTagDiscovery,
            models.BackgroundJobPayloadForPeriodicTenableNessus,
            models.BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync,
            models.BackgroundJobPayloadForPeriodicUnitPriceRate,
            models.BackgroundJobPayloadForPeriodicUpdateCSPAuthDetails,
            models.BackgroundJobPayloadForPeriodicUpdateSkippedAlertAndJobIdStatus,
            models.BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations,
            models.BackgroundJobPayloadForPeriodicValidateCredentials,
            models.BackgroundJobPayloadForPeriodicVirtualMachinesAgents,
            models.BackgroundJobPayloadForPeriodicVulnerabilitySourceUpdate,
            models.BackgroundJobPayloadForPeriodicWorkloadAssessmentCleanup,
            models.BackgroundJobPayloadForPeriodicWorkloadRecommendationSnapshotDaily,
            models.BackgroundJobPayloadForPeriodicWorkloadResourceSnapshotDaily,
            models.BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryDaily,
            models.BackgroundJobPayloadForPeriodicWorkloadVulnerabilityThreatSummaryMonthly,
            models.BackgroundJobPayloadForPeriodicZabbixGovernance,
            models.BackgroundJobPayloadForPolicyExecution,
            models.BackgroundJobPayloadForPolicyJobStatusUpdate,
            models.BackgroundJobPayloadForPolicyOntologyMigration,
            models.BackgroundJobPayloadForPolicyResourceRecommendationRemoval,
            models.BackgroundJobPayloadForProActiveScannerDetailsParserOnDemand,
            models.BackgroundJobPayloadForPromptCaching,
            models.BackgroundJobPayloadForPromptProfiling,
            models.BackgroundJobPayloadForProviderRecommendations,
            models.BackgroundJobPayloadForReactiveTask,
            models.BackgroundJobPayloadForRecoveryConfiguration,
            models.BackgroundJobPayloadForRefreshRecommendation,
            models.BackgroundJobPayloadForRemediationTemplateExecutor,
            models.BackgroundJobPayloadForReportGeneration,
            models.BackgroundJobPayloadForReservedInstance,
            models.BackgroundJobPayloadForResourceActivityLogSync,
            models.BackgroundJobPayloadForResourceAlertConfiguration,
            models.BackgroundJobPayloadForResourceDashboard,
            models.BackgroundJobPayloadForResourceDependencyRelationship,
            models.BackgroundJobPayloadForResourceDiscovery,
            models.BackgroundJobPayloadForResourceDiscoveryExecution,
            models.BackgroundJobPayloadForResourceLockSync,
            models.BackgroundJobPayloadForResourceTagRemediation,
            models.BackgroundJobPayloadForResourceToSbomMappingAutomatic,
            models.BackgroundJobPayloadForResourcesDuplicationRemoval,
            models.BackgroundJobPayloadForSaasCostProcessing,
            models.BackgroundJobPayloadForSbomParser,
            models.BackgroundJobPayloadForSbomToResourceMappingAutomatic,
            models.BackgroundJobPayloadForScheduleRecommendation,
            models.BackgroundJobPayloadForScheduledTask,
            models.BackgroundJobPayloadForScriptExecution,
            models.BackgroundJobPayloadForSecureScoresConfiguration,
            models.BackgroundJobPayloadForServiceAccountDelete,
            models.BackgroundJobPayloadForServiceAccountFeaturePropagation,
            models.BackgroundJobPayloadForServiceAccountGovernancePropagation,
            models.BackgroundJobPayloadForServiceAccountResourceOntologySync,
            models.BackgroundJobPayloadForServiceAccountSyncStatusPropagation,
            models.BackgroundJobPayloadForServiceImpactAnalysis,
            models.BackgroundJobPayloadForSyncBudgets,
            models.BackgroundJobPayloadForTagDiscovery,
            models.BackgroundJobPayloadForTagPosture,
            models.BackgroundJobPayloadForTagPostureSync,
            models.BackgroundJobPayloadForTemplateExecution,
            models.BackgroundJobPayloadForTerraformTemplateExecution,
            models.BackgroundJobPayloadForThreatResourceActiveRefresh,
            models.BackgroundJobPayloadForThreatVulnerabilityGraphDBSummarySync,
            models.BackgroundJobPayloadForUnitRateCrawler,
            models.BackgroundJobPayloadForUpdateUnitRate,
            models.BackgroundJobPayloadForVirtualMachinesAgents,
            models.BackgroundJobPayloadForWorkFlowReconciller,
            models.BackgroundJobPayloadForWorkloadOntologyMigration,
            models.BackgroundJobPayloadForWorkloadResourceSnapshot,
            models.BackgroundJobPayloadForWorkloadResourceSync,
            models.BackgroundJobPayloadForWorkloadTtlGeneration,
        ];
    }

    fixupFields() {
    }

    /**
     * Optional sub-key for payload.
     */
    identifier: string;

    resume_target: string;

    resume_args: Array<string>;

}
